<template>
    <ul class="footer-menu">

        <li class="inline-block" v-for="(menu, index) in menus" :key="index">
            <router-link :to="menu.path" class="text-whitelight text-size1 font-medium mr-spc14 leading-spc1 hover:text-secondary">
                {{menu.title}}
            </router-link>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "FooterMenu",
        data() {
            return {
                menus: [
                    {
                        path: '#',
                        title: 'Blog themes'
                    },
                    {
                        path: '#',
                        title: 'Portfolio themes'
                    },
                    {
                        path: '#',
                        title: 'Portfolio themes'
                    },
                    {
                        path: '#',
                        title: 'Landing page themes'
                    },
                    {
                        path: '#',
                        title: 'Documentation themes'
                    },
                    {
                        path: '#',
                        title: 'Github Pages themes'
                    },
                    {
                        path: '#',
                        title: 'All premium themes'
                    },
                    {
                        path: '#',
                        title: 'All free themes'
                    }
                ]
            }
        }
    }
</script>

<style scoped>

</style>